$(document).ready(function () {
    const hash = window.location.hash;
    const header_h = $('.fixed-header').innerHeight();
    if (hash) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top - header_h
        }, 1000);
    }

    $(document).on("click", "a[href*='#']:not([href^='#']), .anchor-link", function (e) {
        e.preventDefault();

        const currentPositionY = $(window).scrollTop();

        const targetHref = $(this).attr('href');
        const targetId = targetHref.substring(targetHref.indexOf('#') + 1);
        const targetElement = $('#' + targetId);

        let header_h = 64;

        if($(this).hasClass('anchor-link') && $(this).closest('.anchors-wrap')) {
            header_h = header_h + $(this).closest('.anchors-wrap').innerHeight() + 20;
        }


        if (targetElement.length) {
            $('html, body').animate({
                scrollTop: targetElement.offset().top - header_h
            }, 1000);
        } else {
            window.location.href = targetHref;
        }
    });
});

